import React from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";
import styles from "./AccountActivation.module.scss";
import Button from "@material-ui/core/Button";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";
import Paper from "@material-ui/core/Paper";

import { fetchAsyncActivation } from "./authSlice";
import { Grid } from "@material-ui/core";

const useStyle = makeStyles((theme: Theme) => ({
  btn: {
    zIndex: 3,
    backgroundColor: "rgba(41, 156, 243, 0.7)",
    marginTop: 20,
  },
}));

const AccountActivation = () => {
  const classes = useStyle();
  const params = useParams();
  const dispatch = useDispatch();
  const history = useHistory();

  const activation = async () => {
    await dispatch(fetchAsyncActivation(params));
    history.push("/login");
  };
  return (
    <Grid container component="main">
      <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
        <div className={styles.container}>
          <div className={styles.hero}></div>
          <div className={styles.main}>
            <div className={styles.text}>
              リンクを押していただくと本登録が完了します。
            </div>
            <Button
              variant="contained"
              color="primary"
              className={classes.btn}
              onClick={activation}
            >
              本登録
            </Button>
            <div className={styles.logo}>
              <div className={styles.imgContainer}>
                <img
                  src={`${window.location.origin}/logo512.png`}
                  alt=""
                  className={styles.img}
                />
              </div>
              <div>torememo</div>
            </div>
          </div>
        </div>
      </Grid>
    </Grid>
  );
};

export default AccountActivation;
